{
  "partner": {
    "yobante": "Yobante Express",
    "sawa": "Sawa Delivery",
    "yango": "Yango Delivery",
    "own_fleet": "Livraison Djayma"
  },
  "slots": {
    "title": "Choisir un créneau de livraison",
    "loading": "Chargement des créneaux...",
    "select_zone_date": "Veuillez sélectionner une zone et une date.",
    "none_available": "Aucun créneau disponible pour cette date.",
    "full": "Complet",
    "remaining": "{{count}} place restante",
    "remaining_plural": "{{count}} places restantes"
  },
  "zone": {
    "title": "Zone de livraison",
    "from_price": "À partir de {{price}}",
    "minutes": "{{count}} min",
    "hours": "{{count}} h",
    "hours_minutes": "{{hours}} h {{minutes}} min",
    "zones": {
      "dakar": "Dakar",
      "thies-mbour": "Thiès-Mbour",
      "kaolack": "Kaolack",
      "saint-louis": "Saint-Louis",
      "fatick": "Fatick",
      "diourbel-touba": "Diourbel-Touba"
    }
  },
  "tracking": {
    "title": "Suivi de livraison",
    "status": {
      "pending": "En attente",
      "preparation": "Préparation",
      "en_route": "En route",
      "arrived": "Arrivé",
      "delivered": "Livré",
      "cancelled": "Annulé"
    },
    "cancelled": "Cette livraison a été annulée.",
    "driver_info": "Votre livreur",
    "estimated_arrival": "Arrivée estimée :",
    "map_placeholder": "Suivi en temps réel bientôt disponible"
  },
  "yango": {
    "title": "Console Yango",
    "subtitle": "Expédier et suivre les livraisons via Yango",
    "refresh": "Actualiser",
    "dispatch": "Expédier via Yango",
    "confirm_dispatch": "Confirmer l'expédition de {{ref}} ?",
    "confirm": "Confirmer",
    "cancel_action": "Annuler",
    "search_placeholder": "Rechercher par commande, client ou adresse...",
    "empty": "Aucune expédition Yango pour le moment.",
    "error": "Impossible de charger les expéditions. Veuillez réessayer.",
    "retry": "Réessayer",
    "filter": {
      "all": "Toutes",
      "pending": "En attente",
      "searching": "Recherche",
      "in_transit": "En transit",
      "delivered": "Livrées",
      "failed": "Échouées",
      "cancelled": "Annulées"
    },
    "status": {
      "pending": "En attente",
      "searching_driver": "Recherche chauffeur",
      "driver_assigned": "Chauffeur assigné",
      "pickup_arrived": "Arrivé au point de collecte",
      "in_transit": "En transit",
      "delivered": "Livré",
      "cancelled": "Annulé",
      "failed": "Échoué"
    },
    "col": {
      "order_ref": "Commande",
      "customer": "Client",
      "address": "Adresse de livraison",
      "status": "Statut",
      "driver": "Chauffeur",
      "cost": "Coût",
      "date": "Date"
    },
    "kpi": {
      "total_dispatches": "Expéditions totales",
      "total_cost": "Coût total",
      "avg_cost": "Coût moyen",
      "pending": "En cours",
      "delivered": "Livrées",
      "failed": "Échouées"
    }
  }
}
